import * as React from "react";
const CASESVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="rgba(238, 65, 55, 1)"
      strokeWidth={1.5}
      d="M3.213 9.071a4.142 4.142 0 1 1 5.858-5.858L20.787 14.93a4.142 4.142 0 1 1-5.858 5.858L3.213 9.071Z"
    />
    <path
      stroke="rgba(238, 65, 55, 1)"
      strokeWidth={1.5}
      d="m12 17.858-2.929 2.929a4.142 4.142 0 0 1-5.858-5.858L6.143 12 12 17.858Zm0-11.716 2.93-2.929a4.142 4.142 0 0 1 5.857 5.858L17.857 12 12 6.142Z"
    />
    <path
      fill="rgba(238, 65, 55, 1)"
      d="M15.841 12.871a.788.788 0 1 1-1.083 1.143.788.788 0 0 1 1.083-1.143ZM12.13 9.159a.787.787 0 1 0-1.113 1.113.787.787 0 0 0 1.113-1.113Zm4.641 6.497a.789.789 0 1 1-1.115 1.115.789.789 0 0 1 1.115-1.115ZM9.345 8.23A.789.789 0 1 0 8.23 9.346.789.789 0 0 0 9.345 8.23Zm3.712 3.713a.787.787 0 1 1-1.113 1.114.787.787 0 0 1 1.113-1.114Zm.928 2.785a.787.787 0 1 1-1.068 1.157.787.787 0 0 1 1.068-1.157Zm-3.712-3.713a.787.787 0 1 0-1.113 1.112.787.787 0 0 0 1.113-1.112Z"
    />
  </svg>
);
export default CASESVG;
